
import { defineComponent, computed, ref, onMounted } from "vue";
import type { ITeachersModel, IIdentitiesModel, ICountriesModel, IDepartmentsModel, IStatesModel } from "@/interfaces/modules/";

import IdentitiesServices from "@/api/Configuration/IdentitiesService";
import CountriesServices from "@/api/Location/CountriesService";
import DepartmentsServices from "@/api/Location/DepartmentsService";
import StatesServices from "@/api/Location/StatesService";

export default defineComponent({
  name: "PersonelInformation",
  props: {
    record: { type: Object as () => ITeachersModel, required: true },
    wasValidated: { type: Boolean, default: false }
  },
  emits: ["update:record"],
  setup(props, { emit }) {
    const recordProxy = computed<ITeachersModel>({
      get: () => props.record,
      set: (val) => emit("update:record", val),
    });

    // Dropdown data
    const Documents = ref<IIdentitiesModel[]>([]);
    const Country = ref<ICountriesModel[]>([]);
    const Department = ref<IDepartmentsModel[]>([]);
    const City = ref<IStatesModel[]>([]);

    const GenderOptions = [
      "Femenino",
      "Masculino",
      "No_binario",
      "Genero_fluido",
      "Prefiero_no_decirlo",
    ];

    const HousingOptions = [
      { value: "Casa", text: "Casa" },
      { value: "Apartamento", text: "Apartamento" },
      { value: "Habitación", text: "Habitación" },
      { value: "Rural", text: "Rural" },
      { value: "Otro", text: "Otro" },
    ];

    const toNumber = (v: any) =>
      v === "" || v === null || v === undefined ? null : Number(v);

    const updateField = (key: keyof ITeachersModel, value: any) => {
      recordProxy.value = { ...recordProxy.value, [key]: value };
    };

    const invalidEmail = (email?: string) => {
      if (!email) return false; // optional field
      // basic pattern check; keep it simple to avoid over-restricting
      return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const onFileChange = (e: Event, key: "Image" | "Signature") => {
      const input = e.target as HTMLInputElement;
      const file = input?.files?.[0];
      if (!file) return;
      // If back-end expects base64 or name/path, adjust as needed:
      updateField(key as any, file.name);
      // you could also store File in a parallel prop or emit a separate event if required
    };

    const fileName = (val: string) => (val || "").split(/[\\/]/).pop();

    const load = async () => {
      Documents.value = await IdentitiesServices.GetIdentities();
      Country.value = await CountriesServices.GetCountries();
      Department.value = await DepartmentsServices.GetDepartments();
      City.value = await StatesServices.GetStates();
    };

    onMounted(load);

    return {
      recordProxy,
      updateField,
      toNumber,
      Documents,
      Country,
      Department,
      City,
      GenderOptions,
      HousingOptions,
      onFileChange,
      fileName,
      invalidEmail,
    };
  },
});
